import React from 'react';

import withStyles from '@mui/styles/withStyles';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

import { allevaOrangeColor } from '../md/assets/jss/material-dashboard-pro-react.jsx';
import kSelectStyle from '../assets/jss/crm/components/kSelectStyle.jsx';

const allevaOrange = allevaOrangeColor[0];

/*
Package up the lovely functionality of the Single Select found in
Material Dashboard's ExtendedForms into a convenient component

Call it with
  <KSelect
    id="<some unique string>"
    name="<can be used, if desired, to distinguish state variable, allowing
          a unified 'handleSelectChange' function>"
    fullWidth={T/F}
    label="<the string you want as initial quasi-value and eventual label above>"
    disabledOption="<Choose . . .>" //shows up disabled in first place in menu; optional
    liveOptions={[<list of strings to appear as options>]}
    liveValues={[<list of things to use as 'value's of options]} //optional
    value={<string representing chosen option>}
    onChange={<event => function to call when selection changes>}
  />
*/

class KSelect extends React.Component {
  render() {
    const { classes, liveOptions, required } = this.props;
    const liveValues = this.props.liveValues || liveOptions;

    // This next line is necessary to avoid supplying 'undefined' as the 'value' prop of the Select
    // If you do supply 'undefined', the component is understood to be 'uncontrolled,'
    // with the effect that future value props will be ignored.
    const valueProp = typeof this.props.value === 'undefined' ? '' : this.props.value;

    let params = { className: classes.selectLabel /* htmlFor: this.props.id */ };
    if (required) {
      params = { ...params, style: { color: allevaOrange } };
    }

    return (
      <FormControl variant="standard" fullWidth={this.props.fullWidth} className={classes.selectFormControl}>
        {this.props.label && <InputLabel {...params}>{this.props.label}</InputLabel>}
        <Select
          variant="standard"
          MenuProps={{
            className: classes.selectMenu,
          }}
          classes={{
            select: classes.select,
          }}
          value={valueProp}
          disabled={this.props.disabled}
          onChange={this.props.onChange}
          IconComponent={this.props.disabled ? 'ArrowDropDownIcon' : ArrowDropDownIcon}
          inputProps={{
            name: this.props.name,
            id: this.props.id,
          }}
        >
          {this.props.disabledOption && (
            <MenuItem
              disabled
              classes={{
                root: classes.selectMenuItem,
              }}
              value={this.props.disabledOption}
            >
              {this.props.disabledOption}
            </MenuItem>
          )}
          {liveOptions &&
            liveOptions.map((option, i) => (
              <MenuItem
                key={i}
                classes={{
                  root: classes.selectMenuItem,
                  selected: classes.selectMenuItemSelected,
                }}
                value={liveValues[i]}
              >
                {option}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    );
  }
}

export default withStyles(kSelectStyle)(KSelect);
